import React, { useEffect } from "react";
import { CoObjectItem } from "../interfaces/CoObject";
import LoadingManager from "../../common/loading/LoadingManager";
import { SELECT_COOBJECTS_NOTIFICATION } from "../../utils/constants/notification";
import { getDocumentCoObjects } from "../../utils/helpers/ContentControlHelper";

export interface AllCoObjectsSelectorProps {
  children: (coObjects: CoObjectItem[], reloadCoObjects: () => void) => React.JSX.Element;
}

export const AllCoObjectsSelector = (props: AllCoObjectsSelectorProps) => {
  const [coObjects, setCoObjects] = React.useState<CoObjectItem[]>(null);

  // MOVE! to this redux when we have the object lifecycle workflow
  // const dispatch = useAppDispatch();
  // const coObjects = useAppSelector(documentCoObjects);

  const loadDocumentCoObjects = async () => {
    try {
      LoadingManager.create(SELECT_COOBJECTS_NOTIFICATION);
      const loaded: CoObjectItem[] = await getDocumentCoObjects();
      setCoObjects(loaded);
    } catch (error) {
      console.error("Failed to load CoObjects", error);
      setCoObjects(null); // or set an error state if needed
    } finally {
      LoadingManager.remove(SELECT_COOBJECTS_NOTIFICATION);
    }
  };

  useEffect(() => {
    void loadDocumentCoObjects();
  }, []);

  if (coObjects) return props.children(coObjects, loadDocumentCoObjects);
  //TODO handle failures
  return null;
};
